import { useEffect, useState } from "react";
import { TrendingUp, TrendingDown } from "lucide-react";
import { http } from "@/lib/adminApi";

const money = (n) => { const v = Number(n || 0); return `$${v.toLocaleString(undefined, { minimumFractionDigits: Number.isInteger(v) ? 0 : 2, maximumFractionDigits: 2 })}`; };

const Tile = ({ label, value, sub, testid, big }) => (
  <div className={`rounded-2xl border border-white/10 p-5 ${big ? "bg-[var(--teal)] text-[var(--ink)] sm:col-span-2" : "bg-[var(--navy)]"}`} data-testid={testid}>
    <p className={`font-mono-d text-[11px] uppercase tracking-[0.2em] ${big ? "text-[var(--ink)]/70" : "text-[var(--teal)]"}`}>{label}</p>
    <p className={`font-serif-d mt-2 leading-none ${big ? "text-6xl" : "text-4xl text-white"}`}>{value}</p>
    {sub && <div className={`mt-2 text-sm ${big ? "text-[var(--ink)]/80" : "text-slate-300"}`}>{sub}</div>}
  </div>
);

export const StatsBar = () => {
  const [s, setS] = useState(null);
  useEffect(() => {
    http.get("/admin/stats").then((r) => setS(r.data || null)).catch(() => setS(null));
  }, []);
  if (!s) return null;

  const diff = (s.revenue ?? 0) - (s.last_month_revenue ?? 0);
  const Trend = diff >= 0 ? TrendingUp : TrendingDown;
  return (
    <section className="mt-10" data-testid="admin-stats">
      <p className="text-sm text-slate-300">{s.month_label}</p>
      <div className="mt-3 grid gap-3 sm:grid-cols-4">
        <Tile big testid="stat-revenue" label="Revenue this month" value={money(s.revenue)}
          sub={<span className="inline-flex items-center gap-1"><Trend className="h-4 w-4" /> {diff >= 0 ? "+" : "-"}{money(Math.abs(diff))} vs last month ({money(s.last_month_revenue)})</span>} />
        <Tile testid="stat-orders" label="Paid orders" value={s.orders ?? 0} sub={`Avg ${money(s.avg_order)} · ${s.rush_orders ?? 0} rush`} />
        <Tile testid="stat-top-plan" label="Most popular" value={s.top_plan?.name || "—"}
          sub={s.top_plan ? `${s.top_plan.count} order${s.top_plan.count === 1 ? "" : "s"} ${s.top_plan.scope}` : "No orders yet"} />
      </div>
      <p className="mt-3 text-xs text-slate-400">All time: {money(s.all_time_revenue)} · {s.referred_orders ?? 0} referred order{s.referred_orders === 1 ? "" : "s"} this month · Central time</p>
    </section>
  );
};
